<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem to="/host/index/set/news">行业动态</BreadcrumbItem>
          <BreadcrumbItem>编辑动态</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">编辑动态</div>
      </div>
      <div class="f-tar" style="margin:36px 0;">
        <Button @click="$router.push('/host/index/set/news')">返回</Button>
      </div>
    </div>
    <div class="my-item">
      <div class="addcertificate">
        <div class="addcertificate-box">
          <div class="my-modal">
            <div class="my-modal-content">
              <Form ref="formInline" :label-width="130" :model="formInline" :rules="ruleInline">
                <FormItem label="资讯封面：" :required="true">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList"
                    :key="'upload' + index"
                    style="width: 100px;height: 100px;line-height:100px;margin-bottom:0;"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" style="width:100%;height:100%;" />
                      <div class="my-upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        <Icon
                          type="ios-trash-outline"
                          @click.native.stop.prevent="handleRemoveByArr(item)"
                        ></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    type="drag"
                    :action="uploadUrl"
                    multiple
                    style="display: inline-block;width:100px;"
                    v-show="uploadList && uploadList.length < 1"
                  >
                    <div style="width: 100px;height:100px;padding-top:15px;color:rgb(133, 133, 133);">
                      <div style="font-size:25px;">
                        +
                        <p style="font-size:14px;">上传图片</p>
                      </div>
                    </div>
                  </Upload>
                  <p style="font-size:12px;">(图片要求：2M以下的jpg或png，建议尺寸260*170px)</p>
                </FormItem>
                <FormItem label="资讯标题：" prop="title">
                  <Input v-model="formInline.title" placeholder="请输入资讯标题" />
                </FormItem>
                <FormItem label="链接地址：">
                  <Input v-model="formInline.link" placeholder="请输入链接地址" />
                </FormItem>
                <FormItem label="资讯概要：" prop="summary">
                  <Input type="textarea" :rows="6" v-model="formInline.summary" placeholder="请输入资讯概要" />
                </FormItem>
                <FormItem label="资讯内容：" :required="true">
                  <div ref="editorElement"></div>
                </FormItem>
                <FormItem label="发布时间：">
                  <DatePicker type="datetime" v-model="formInline.pubTime" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择发布时间"></DatePicker>
                </FormItem>
                <FormItem>
                  <Checkbox v-model="formInline.isTopic">&nbsp;是否置顶</Checkbox>
                </FormItem>
                <FormItem>
                  <Button
                    type="primary"
                    size="large"
                    :loading="loading"
                    @click="handleSubmit('formInline')"
                    style="width:140px;height:35px;font-size:14px;"
                  >保存</Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <iModal title="图片查看" cancel-text v-model="visible" :z-index="10002">
      <div style="text-align: center;">
        <img :src="imgName" v-if="visible" style="max-width: 100%" />
      </div>
    </iModal>
  </div>
</template>

<script>
import config from '@assets/config.json';
import axios from 'axios';
import { mapActions, mapGetters } from "vuex";
import wangeditor from "wangeditor";

export default {
  name: "add-news",
  data() {
    return {
      editor: null,
      editInfo: null,
      imgName: "",
      loading: false,
      formInline: {
        title: "", // 标题
        summary: "", // 概要
        link: "", // 链接
        pubTime: "", // 发布时间
        isTopic: false, // 是否置顶
        content: "", // 内容
      },
      ruleInline: {
        // 效验规则
        title: [
          { required: true, message: "请输入资讯标题", trigger: "blur" },
        ],
        summary: [
          { required: true, message: "请输入资讯概要", trigger: "blur" }
        ],
      },
      uploadList: [],
      defaultList: [],
      visible: false,
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
    newId() {
      return this.$route.query.id;
    }
  },
  methods: {
    ...mapActions({
      editHostNews: "hostAuditModule/editHostNews",
      getHostNewsById: "hostAuditModule/getHostNewsById",
    }),
    async init() {
      let editInfo = await this.getHostNewsById(this.newId);
      if (editInfo) {
        this.editInfo = editInfo;
        this.formInline.title = editInfo.title;
        this.uploadList = [
          {
            url: editInfo.coverUrl,
            status: "finished",
            percentage: 100
          }
        ]
        this.formInline.link = editInfo.link;
        this.formInline.summary = editInfo.summary;
        this.formInline.pubTime = editInfo.pubTime;
        this.formInline.isTopic = editInfo.isTopic;
        this.formInline.content = JSON.parse(this.editInfo.introduction);
        this.editor.txt.html(JSON.parse(this.editInfo.introduction));
      }
      // console.log("编辑信息：",editInfo);
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    async handleSubmit(name,e) {
      let form = this.formInline;
      let imgList = this.transfromImgList(this.uploadList);
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!(this.uploadList && this.uploadList.length)) {
        this.$Message.error(`请上传资讯封面`);
        return;
      }
      if (!(this.formInline.content)) {
        this.$Message.error(`请输入资讯内容`);
        return;
      }

      let pubTime = "";
      if (form.pubTime) {
        pubTime =  moment(form.pubTime).format("YYYY-MM-DD HH:mm:ss");
      } else {
        pubTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      }
      let formData = {
        Id: this.editInfo.id,
        SetValues: {
          Title: form.title,
          CoverUrl: imgList[0],
          Summary: form.summary,
          Introduction: JSON.stringify(form.content),
          Link: form.link,
          PubTime: pubTime,
          IsTopic: form.isTopic
        }
      };
      this.loading = true;
      let bool = await this.editHostNews(formData);
      this.loading = false;
      if (bool.successed) {
        this.$Message.success("保存成功");
        this.$router.push("/host/index/set/news");
      } else {
        this.$Message.error("保存失败，请重新尝试");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
  },
  mounted() {
    this.editor = new wangeditor(this.$refs.editorElement);
    this.editor.customConfig.zIndex = 1;
    // 赋值
    this.editor.customConfig.onchange = e => {
      this.formInline.content = e;
    };

    // 上传图片配置
    const that = this;
    this.editor.customConfig.customUploadImg = function (files, insert) {
      // console.log(files)
      files.forEach((item) => {
        let fd = new FormData();
        fd.append('file', item); // 上传的文件： 键名，键值
        axios.post(`${config.api.reqApi}/api/CtyunOSS/images`, fd).then(data => {
        if (data.data.successed) {
          insert(data.data.list[0]);
        } else {
          that.$Message.error("上传失败，请重试！"); 
        }
      }).catch((err) => {
        that.$Message.error("上传失败，请重试！"); 
        console.log(err.response.data);
      });
      })
    }
    
    this.editor.customConfig.menus = [
      // 菜单配置
      'head', // 标题
      'bold', // 粗体
      'fontSize', // 字号
      'fontName', // 字体
      'italic', // 斜体
      'underline', // 下划线
      'strikeThrough', // 删除线
      'foreColor', // 文字颜色
      'backColor', // 背景颜色
      'link', // 插入链接
      'list', // 列表
      'justify', // 对齐方式
      'quote', // 引用
      'emoticon', // 表情
      'image', // 插入图片
      'table', // 表格
      'code', // 插入代码
      'undo', // 撤销
      'redo' // 重复
    ];
    this.editor.create(); // 创建富文本实例

    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.addcertificate {
  padding: 50px 0;
  background: #fff;
  &-box {
    padding: 20px 85px 40px;
    max-width: 1000px;
  }
}
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.preview {
  cursor: pointer;
}
</style>